// extracted by mini-css-extract-plugin
export default {"badgeWrapper":"ln-z","badgeLink":"mn-z","category":"nn-z"};